import React from 'react';

export default function Logo() {
    return (
        <h1 className="logo">
            Konto Kandydata
            <i className="logo__circle logo__circle--blue" />
            <i className="logo__circle logo__circle--dark" />
        </h1>
    );
}
